export default __webpack_public_path__ + "static/media/Menu_Mobile.bd84530c.svg";